export enum FileStatus {
    None = 0,
    Loading = 1,
    Failure = 2,
    Success = 3,
}